import { styled } from "@mui/system";
import { Button } from "@mui/material";

export const TabButton = styled(Button)(({ theme }) => ({
    borderRadius: 0,
    border: "1px solid transparent",
    textTransform: "none",
    padding: "3px 10px",
    height: "40px",
  
    "& .MuiTypography-root": {
      fontSize: "14px", 
      lineHeight: "140%", 
      letterSpacing: "1%", 
      textAlign: "left", 
      verticalAlign: "middle",
      fontWeight: "bold",
    },
  
    "& .MuiSvgIcon-root": {
      marginRight: "8px", 
      fontSize: "18px"
    },
  
    "&.MuiButton-contained": {
      backgroundColor: "#A5E0FF",
      width: "128px",
      color: "#2B3342",
      borderColor: "#A1A5AC",

      "& .MuiTypography-root": {
        fontWeight: "bold !important",
      },
      "&:hover": {
        borderColor: "#FFFFFF",
      },
    },
  
    "&.MuiButton-outlined": {
      backgroundColor: "transparent",
      width: "128px",
      borderColor: "#A1A5AC",
      color: "#F8F8F8",
      "&:hover": {
        borderColor: "#FFFFFF",
        backgroundColor: "rgba(144, 202, 249, 0.08)",
      },
    },
  
    "&:first-of-type": {
      borderRight: "0px",
      borderTopLeftRadius: "100px",
      borderBottomLeftRadius: "100px",
    },

    "&:last-of-type": {
      borderTopRightRadius: "100px",
      borderBottomRightRadius: "100px",
    },
  }));
  